import currencyStore from './storage/currencyStore';

const MS_TO_CACHE_CURRENCY_CONVERSIONS = 86400000; // 1 day
const MS_TO_CACHE_SUPPORTED_CURRENCIES = 604800000; // 1 week

function getConversionRatesForCurrency(currency) {
    const conversionRateMap = currencyStore.getConversionRates() || {};
    const currencyConversionRates = conversionRateMap[currency];

    if (!currencyConversionRates) {
        return null;
    }

    if (_conversionRateHasExpired(currency)) {
        return null;
    }

    return currencyConversionRates.rates;
}

function getAllConversionRates() {
    const conversionRates = currencyStore.getConversionRates() || {};

    return Object.entries(conversionRates)
        .filter(([currency, data]) => {
            return !_conversionRateHasExpired(currency);
        }).reduce((obj, [currency, data]) => {
            return {
                ...obj,
                [currency]: data.rates,
            };
        }, {});
}

function _conversionRateHasExpired(currency) {
    const conversionRateMap = currencyStore.getConversionRates();
    const updatedOn = conversionRateMap[currency].meta.updatedOn;
    const now = Date.now();
    return now - updatedOn >= MS_TO_CACHE_CURRENCY_CONVERSIONS;
}

function setConversionRatesForCurrency(currency, conversionRates) {
    const storedCurrencyRateMap = currencyStore.getConversionRates() || {};

    const conversionRateMap = Object.entries(conversionRates)
        .reduce((obj, [toCurrency, conversionRate]) => {
            return {
                ...obj,
                [toCurrency]: conversionRate,
            };
        }, {});

    storedCurrencyRateMap[currency] = {
        meta: {
            updatedOn: Date.now(),
        },
        rates: conversionRateMap,
    };

    currencyStore.setConversionRates(storedCurrencyRateMap);
}

function getSupportedCurrencies() {
    const supportedCurrencies = currencyStore.getSupportedCurrencies();

    if (!supportedCurrencies) {
        return null;
    }

    if (_supportedCurrenciesHasExpired(supportedCurrencies)) {
        return null;
    }

    return supportedCurrencies.data;
}

function _supportedCurrenciesHasExpired(supportedCurrencies) {
    const updatedOn = supportedCurrencies.meta.updatedOn;
    const now = Date.now();
    return now - updatedOn >= MS_TO_CACHE_SUPPORTED_CURRENCIES;
}

function setSupportedCurrencies(supportedCurrencies) {
    const augmentedSupportedCurrenciesObj = {
        meta: {
            updatedOn: Date.now(),
        },
        data: supportedCurrencies,
    };
    currencyStore.setSupportedCurrencies(augmentedSupportedCurrenciesObj);
}

export {
    getAllConversionRates,
    getConversionRatesForCurrency,
    getSupportedCurrencies,
    setConversionRatesForCurrency,
    setSupportedCurrencies,
};

export default {
    getAllConversionRates,
    getSupportedCurrencies,
    setSupportedCurrencies,
    getConversionRatesForCurrency,
    setConversionRatesForCurrency,
};
